









































































import { Vue, Component, Prop } from 'vue-property-decorator';
import ChatBalloon from '@/components/chat/chatBalloon.vue';
import ChatForm from '@/components/chat/chatForm.vue';
import { MessageComment } from '@/modules/message';
import { Student } from '@/modules/student';
import { AttachmentFile } from '@/models/attachmentFile';
import { ReadTypes } from '@/enums/readTypes';
import { PublicTypes } from '@/enums/publicTypes';
import { UserTypes } from '@/enums/userTypes';
import { ReturnTypes } from '@/enums/returnTypes';
import 'quill/dist/quill.core.css';

interface ChatMessage {
  name: string;
  speaker: string;
  message: string;
  date: string;
}

@Component({
  components: {
    'chat-balloon': ChatBalloon,
    'chat-form': ChatForm
  }
})
export default class CommentView extends Vue {
  private ReadTypes = ReadTypes;
  private PublicTypes = PublicTypes;

  @Prop() private messageId: string;
  @Prop() private studentId: string;

  private student: Student | null = null;

  private uploadFilePreview = {
    visible: false,
    title: '',
    filePath: '',
    fileRaw: {},
  };

  get message(): MessageComment {
    return this.$store.state.message.selectedComment;
  }

  get attachments(): AttachmentFile[] {
    if (!this.message) {
      return [];
    } else {
      return this.message.attachmentList.filter((file) => !file.isDelete);
    }
  }

  get unReadComment() {
    if (!this.message) {
      return false;
    } else {
      return !!this.message.commentList.find((comment) => {
        return comment.sendUserType === UserTypes.Student
                && comment.readType === ReadTypes.Unread;
      });
    }
  }

  get studentName(): string {
    if (!this.student) {
      return '';
    } else {
      return `${this.student.lastName}　${this.student.firstName}`;
    }
  }

  get pageTitle(): string {
    return `
      <div>
        <span style="font-size:x-large; font-weight:bold;">${this.studentName}</span>
        <span style="font-size:medium; margin-left:10px;">さんのコメント</span>
      </div>`;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get schoolId(): string {
    return this.$store.getters['auth/schoolId'];
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private async loadData() {
    try {
      this.student = await this.$store.dispatch('student/getStudent', this.studentId);
      await this.$store.dispatch('message/selectComment', {
        messageId: this.messageId,
        studentId: this.studentId
      });
    } catch (error) {
      //
    }

    if (!this.student || !this.message || this.message.returnType === ReturnTypes.Disable) {
      this.$router.push({
        name: 'MessageDetails',
        params: {
          messageId: this.messageId
        }
      });
    }
  }

  private async onPreviewUploadFile(file: AttachmentFile) {
    const result = await this.$store.dispatch('file/setAttachmentFileInfo', file);
    if (!result) { return; }

    if (!!file.localUrl) {
      if (!!file.raw && /^image\//.test(file.raw.type)) {
        this.uploadFilePreview.title = file.name;
        this.uploadFilePreview.filePath = file.localUrl;
        this.uploadFilePreview.fileRaw = file.raw;
        this.uploadFilePreview.visible = true;
      } else {
        const fileName = file.name;
        if (!(window.navigator as any).msSaveOrOpenBlob) {
          const link = document.createElement('a');
          link.href = file.localUrl as string;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (!!file.raw) {
          const url = (window.navigator as any).msSaveOrOpenBlob(file.raw, fileName);
        }
      }
    }
  }

  private async getAttachmentBlob(url: string): Promise<Blob> {
    try {
      return await this.$store.dispatch('message/getAttachment', url);
    } catch (error) {
      throw error;
    }
  }

  // 既読登録
  private async onSeen() {
    const commentIdList = this.message.commentList
      .filter((comment) => {
        return comment.readType === ReadTypes.Unread
                && comment.sendUserType === UserTypes.Student;
      })
      .map((comment) => comment.id);

    if (commentIdList.length === 0) { return; }

    try {
      await this.$store.dispatch('message/readComment', commentIdList);
    } catch (error) {
      this.$notify.error({
        title: '既読登録エラー',
        message: error.message,
        position: 'bottom-right',
      });
      return;
    }

    this.$notify({
      title: '既読登録完了',
      message: 'コメントを既読にしました',
      position: 'bottom-right',
    });

    this.loadData();

    this.scrollDown();
  }

  // コメント送信
  private async inputComment({ message, imageList }: { message: string, imageList: File[] }) {
    if (imageList.length === 0 && message === '') {
      return;
    }

    try {
      const commentIdList = this.message.commentList
        .filter((comment) => {
          return comment.readType === ReadTypes.Unread
                  && comment.sendUserType === UserTypes.Student;
        })
        .map((comment) => comment.id);

      if (commentIdList.length > 0) {
        await this.$store.dispatch('message/readComment', commentIdList);
      }

      await this.$store.dispatch('message/sendComment', {
        messageId: this.messageId,
        studentId: this.studentId,
        schoolId: this.schoolId,
        comment: message,
        imageList,
      });
    } catch (error) {
      this.$notify.error({
        title: 'コメント登録エラー',
        message: error.message,
        position: 'bottom-right',
      });
      return;
    }

    this.loadData();

    this.scrollDown();
  }

  private scrollDown() {
    const target: any = this.$el.querySelector('.chat-timeline');
    setTimeout(() => {
      const height = target.scrollHeight - target.offsetHeight;
      target.scrollTop += 10;

      if (height <= target.scrollTop) {
        return;
      } else {
        this.scrollDown();
      }
    }, 0);
  }
}
